import React from 'react';
export function FAQsHero() {
  return <section className="bg-slate-50 py-16 md:py-24 border-b border-slate-200" data-id="element-156">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-157">
        <h1 className="text-4xl md:text-5xl font-bold text-[#1a2332] mb-6" data-id="element-158">
          Frequently Asked Questions
        </h1>
        <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-159">
          We're here to answer your questions and help you get started on your
          martial arts journey with confidence.
        </p>
      </div>
    </section>;
}